var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 4.32a.6.6 0 0 1 .6.6v6.48h6.48a.6.6 0 1 1 0 1.2H12.6v6.48a.6.6 0 1 1-1.2 0V12.6H4.92a.6.6 0 1 1 0-1.2h6.48V4.92a.6.6 0 0 1 .6-.6"
  })));
};
export default SvgPlus;